import React, { Suspense, useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { useTranslation } from "react-i18next";
import LoadingSpinner from '../../../atoms/LoadingSpinner';
import "./content-layout.scss";

export function Content({ activeTab, tabs }) {
    const [ActiveComponent, setActiveComponent] = useState(null);
    const { t } = useTranslation();

    useEffect(() => {
        const definition = tabs.find((tab) => tab.id === activeTab);
        setActiveComponent(() => definition?.component ?? null);
    }, [activeTab, tabs])

    return (
        <div className="content-wrapper">
            {ActiveComponent && (
                <Suspense
                    fallback={
                        <div
                            className="content-wrapper__fallback"
                            role="status"
                            aria-live="polite"
                            aria-label={t("app.loadingContent")}
                        >
                            <LoadingSpinner />
                            <p className="content-wrapper__fallback-text">
                                {t("app.loadingContent")}
                            </p>
                        </div>
                    }
                >
                    <ActiveComponent />
                </Suspense>
            )}
        </div>
    );
}

Content.propTypes = {
    activeTab: PropTypes.string.isRequired,
    tabs: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
    })).isRequired,
};
